{
  "customer_groups_resources_card": {
    "header": "Useful guides for managing B2B customers",
    "invite_customers": {
      "title": "Inviting B2B customers",
      "subtitle": "How to invite customers to register and access B2B pricing"
    },
    "customer_setup": {
      "title": "Customer setup",
      "subtitle": "Read our full customer group tagging and assignment guide"
    },
    "payment_methods": {
      "title": "Setting up payment methods",
      "subtitle": "How to customise payment methods such as net terms and pay online"
    }
  },
  "customer_groups_base_card": {
    "header": "Base customer group",
    "description": "These settings apply to every B2B customer. All other groups inherit these settings unless you specifically override them below.",
    "headings": {
      "tag": "Base tag",
      "tag_shopify": "Shopify tag",
      "tag_magento": "Group",
      "tag_wix": "Wix label",
      "price_lists": "Price lists",
      "payment_methods": "Payment methods",
      "other_settings": "Other settings"
    },
    "alert": "Updates made here automatically sync to all inheriting groups below."
  },
  "customer_group_empty_state": {
    "eyebrow": "No additional customer groups yet",
    "title": "Different rules for different customers",
    "description_shopify": "New groups start from your base settings - override only what differs, then tag customers into the group to apply it.",
    "description": "New groups start from your base settings - override only what differs, then add customers to the group to apply it.",
    "create": {
      "badge": "Start here",
      "title": "Create a customer group",
      "description": "Starts from your base settings - change only what this group needs, like price lists or payment methods.",
      "cta": "Create customer group"
    },
    "add_customers": {
      "title": "Then add customers",
      "description_shopify": "Tag customers in Shopify to place them in the group - they get its pricing and rules when they log in.",
      "description": "Add customers to the group - they get its pricing and rules when they log in.",
      "cta": "View customers"
    }
  },
  "customer_groups_table": {
    "caption": "Table of all your customer groups.",
    "headings": {
      "name": "Name",
      "tags": "Tags",
      "tags_shopify": "Shopify Tags",
      "tags_magento": "Groups",
      "tags_wix": "Wix Labels",
      "price_lists": "Price Lists",
      "payment_methods": "Payment Methods",
      "order_limits": "Order Limits",
      "other_settings": "Settings"
    },
    "row": {
      "handle": "Handle: {handle}"
    },
    "other_settings_count": "{count, plural, =1 {1 setting} other {# settings}}",
    "descriptions": {
      "tooltips": {
        "inherit": "Inheriting from \"{parent_name}\"",
        "customized_rules": "Customized rules"
      }
    }
  },
  "delete_customer_group_modal": {
    "confirm_delete": {
      "title": "Delete customer group?",
      "body": "Are you sure you want to delete the \"{name}\" customer group?"
    },
    "status": {
      "errors": {
        "delete_failed": "Failed to delete customer group.",
        "resource_in_use": "The customer group \"{name}\" is in use and has been assigned to customers within your store. To delete this group, please unassign the customers first and then try again."
      },
      "success": {
        "delete_succeeded": "Customer Group \"{name}\" successfully deleted."
      }
    }
  },
  "customer_group_builder_summary_card": {
    "title": "Rules",
    "customized": "Customized rules",
    "inherited": "Inherited rules"
  },
  "customer_group_builder_details_card": {
    "title": "Details",
    "display_name": {
      "label": "Name",
      "placeholder": "e.g. VIP Customers"
    },
    "handle": {
      "label": "Handle (or ID)",
      "placeholder": "e.g. vip"
    },
    "configuration": {
      "label": "Inherit from existing group",
      "placeholder": "Select Group to Inherit"
    },
    "alert": {
      "label": "This group will inherit all settings from the <strong>{name}</strong> customer group unless customized.",
      "button": "View customer group"
    },
    "customer_tags": {
      "label": "Customer {count, plural, =1 {tag} other {tags}}",
      "label_magento": "Customer {count, plural, =1 {group} other {groups}}",
      "label_wix": "Customer {count, plural, =1 {label} other {labels}}",
      "description": "Applied to customers to enable SparkLayer.",
      "link": {
        "label": "View customers"
      }
    }
  },
  "price_lists_card": {
    "title": "Price lists",
    "description": "Choose which price lists will be used for this customer group.",
    "select": {
      "placeholder": "Select a price list"
    },
    "add": "Add price list",
    "priority_info": "You can assign multiple price lists to a customer group. If a product SKU exists in multiple lists, SparkLayer will use the first one it finds.",
    "alert": {
      "title": "Action required"
    },
    "errors": {
      "duplicate": "Each price list can only be added once - please remove any duplicates",
      "empty": "Please select a price list for each entry or remove any empty rows"
    }
  },
  "order_total_limits_card": {
    "title": "Order total limits",
    "description": "Specify the order total limits customers must reach before checking out.",
    "alert": {
      "title": "Action required"
    },
    "min_value": {
      "label": "Minimum order total"
    },
    "max_value": {
      "label": "Maximum order total",
      "placeholder": "No limit"
    },
    "currency": "Currency",
    "add": "Add order total limit",
    "errors": {
      "duplicate_currency_codes": "Each currency can only have one order limit - please remove any duplicates"
    }
  },
  "order_quantity_limit_card": {
    "title": "Order quantity limits",
    "description": "Specify the order quantity limits customers must meet before checking out.",
    "minimum_quantity": {
      "label": "Minimum order quantity",
      "placeholder": "No limit"
    },
    "maximum_quantity": {
      "label": "Maximum order quantity",
      "placeholder": "No limit"
    },
    "range": "Order quantity range"
  },
  "payment_methods_card": {
    "title": "Payment methods",
    "description": "Choose which payment methods will be shown at checkout.",
    "methods": {
      "payment_by_invoice": {
        "label": "Pay by invoice",
        "description": "Allow customers to place an order and invoice them later"
      },
      "payment_on_account": {
        "label": "Payment on account",
        "description": "Allow customers to place orders on account, e.g. net terms and credit"
      },
      "upfront_payment": {
        "label": "Card at checkout",
        "description": "Allow customers to pay online by card"
      },
      "quote": {
        "label": "Request For Quote",
        "description": "Allow customers to submit orders for review",
        "alert": {
          "restricted": {
            "title": "Feature is restricted",
            "description": "You're using an old version of our \"request for quote\". We've released our brand new quoting engine that automates your \"quote to order\" process. Available on the Pro and Enterprise plan."
          },
          "not_enabled": {
            "title": "Feature is not enabled",
            "description": "You're using an old version of our \"request for quote\". We've released our brand new quoting engine that automates your \"quote to order\" process. To enable, remove \"request For quote\" payment method from all customer groups."
          }
        }
      }
    }
  },
  "address_management_card": {
    "title": "Address management",
    "description": "Specify if you want customers to be able to edit their addresses.",
    "allow_address_editing": {
      "label": "Allow address editing in My Account",
      "description": "Allow customers to add or edit their addresses"
    },
    "allow_default_billing_modification": {
      "label": "Allow customers to add and edit billing addresses",
      "description": "Let customers set a default billing address"
    }
  },
  "credit_settings_card": {
    "title": "Credit settings",
    "description": "Manage how credit limits apply to this customer group, including visibility, order restrictions, and account payment limits.",
    "prevent_if_exceeding": {
      "label": "Prevent placing an order if exceeding credit limit",
      "description": "Restrict customers completing an order if they're paying on account"
    }
  },
  "stock_location_card": {
    "title": "Stock location",
    "description": "Specify which stock (inventory) locations you want your customers to use.",
    "label": "Select location",
    "errors": {
      "not_enabled": "Stock location selection is not enabled",
      "restricted": "Stock location selection is available only on our Growth, Pro, and Enterprise plans. Please speak with our team or reset your configuration."
    }
  },
  "stock_display_card": {
    "title": "Stock display",
    "description": "Choose how stock levels are shown to this customer group.",
    "learn_more": "Learn More (opens in a new tab)",
    "suffix": "Units",
    "show_status": {
      "label": "Show stock availability to customers",
      "description": "Customers can see the availability of your products (pre-order is always shown unless \"Hide pre-order\" below is checked)"
    },
    "hide_preorder": {
      "label": "Hide pre-order",
      "description": "Hides the \"pre-order\" stock status from being displayed to customers"
    },
    "show_units": {
      "label": "Show number of units of stock",
      "description": "Show the specific stock number up to the 'Max' specified below"
    },
    "low": {
      "label": "Low",
      "description": "This will show to the customer in yellow and denotes low levels of stock"
    },
    "last": {
      "label": "Last",
      "description": "This will show to the customer in orange and denotes the last remaining stock"
    },
    "max": {
      "label": "Max",
      "description": "This will show to the customer in green. Anything above will show as {number}+"
    }
  },
  "quoting_engine_card": {
    "title": "Quoting engine",
    "description": "Simplify how your sales team and B2B customers create and manage quotes.",
    "allow_submission": {
      "label": "Allow quotes to be submitted",
      "description": "Let customers submit quotes when adding items to an order"
    },
    "errors": {
      "not_enabled": "The quoting engine is not currently enabled. Enable it by removing the \"request For quoting\" payment method from all customer groups or reset your configuration.",
      "restricted": "The quoting engine is available only on our Pro and Enterprise plans. Please upgrade your plan or reset your configuration."
    }
  },
  "allow_checkout_card": {
    "title": "Checkout access",
    "description": "Control whether this customer group can complete purchases.",
    "learn_more": "Learn More (opens in a new tab)",
    "disable_checkbox": {
      "label": "Disable checkout",
      "description": "Customers in this group cannot access the checkout, but they can still submit quotes if quoting is enabled."
    }
  },
  "recurring_orders_engine_card": {
    "title": "Recurring orders",
    "description": "Allow customers to create recurring orders",
    "enable_feature": {
      "label": "Enabled",
      "description": "Allow customers to create recurring orders"
    },
    "allow_creation": {
      "label": "Allow recurring orders to be created",
      "description": "Let customers create recurring orders"
    },
    "errors": {
      "not_enabled": "The recurring orders engine is not currently enabled.",
      "restricted": "The recurring orders engine is available only on our Growth, Pro and Enterprise plans. Please upgrade your plan or reset your configuration."
    }
  },
  "quick_setup": {
    "card": {
      "title": "Customer group"
    },
    "name": {
      "label": "Name",
      "placeholder": "e.g. Wholesale customers, EU distributors"
    },
    "assigned_price_list": {
      "label": "Assigned price list",
      "hint": "You can create and manage price lists from the Price Lists page.",
      "no_price_lists_placeholder": "No price lists available"
    },
    "payment_methods": {
      "label": "Payment methods for this group (select all that apply)"
    },
    "min_order_requirements": {
      "label": "Minimum order requirements (select all that apply)",
      "value_based_min": {
        "label": "Value based minimum (e.g. minimum order value)"
      },
      "order_based_min": {
        "label": "Unit based minimum (e.g. minimum number of items)",
        "suffix": "Units"
      }
    },
    "min_order_value": {
      "label": "Minimum order value ({currency})",
      "placeholder": "e.g. 500"
    },
    "min_order_units": {
      "label": "Minimum number of units",
      "placeholder": "e.g. 10"
    },
    "actions": {
      "submit": "Create customer group"
    }
  },
  "switch_to_quick_setup_modal": {
    "confirm_switch": {
      "title": "Switch to quick setup?",
      "body": "Switching to quick setup will discard any unsaved changes made here. Are you sure you want to continue?",
      "confirm": "Switch to quick setup"
    }
  },
  "customized_rules_card": {
    "title": "Customized rules"
  },
  "override_settings_card": {
    "title": "Inherited rules",
    "notification": {
      "errors": {
        "customer_groups": "customer groups",
        "price_lists": "price lists",
        "stock_locations": "stock locations",
        "fetch": "Failed to get summary data for {failedItems}"
      }
    }
  }
}
